import React, { Component } from "react";
import "../ComplaintsComponent.mobile.css";
import { connect } from "react-redux";
import { getInvoiceDetails } from "../../../actions/complaintsDataAction";
import Loader from "react-loader-spinner";

class InvoiceDetails extends Component {
  state = {
    isLoading: false, // loader state
  };

  handleGetInvoiceDetails = async () => {
    const { item, dispatch } = this.props;
    const complaint_id = item.id;
    const invoice_url = item.invoice_url;

    this.setState({ isLoading: true }); // show loader

    try {
      const response = await dispatch(
        getInvoiceDetails({ complaint_id, invoice_url })
      );
      console.log("Invoice details fetched:", response);

      if (response?.success) {
        alert("Invoice details successfully fetched and saved.");
        window.location.reload();
      } else {
        alert(response?.message || "Failed to fetch invoice details.");
        this.setState({ isLoading: false }); // hide loader if not success
      }
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      alert(error.message || "Something went wrong.");
      this.setState({ isLoading: false }); // hide loader on error
    }
  };

  render() {
    const { item } = this.props;
    const { isLoading } = this.state;
    const invoiceData = item.invoice_data || {};
    // if(invoiceData.is_valid == 0 || invoiceData.is_valid == '0'){
    //   alert("Invalid Invoice");
    // }
    const showButton =
      Object.keys(invoiceData).length === 0

    // Show loader instead of button or invoice details
    if (isLoading) {
      return (
        <div className="loader-container">
          <Loader type="Oval" color="grey" height={100} width={100} />
          <p style={{ marginTop: 10 }}>Fetching invoice details...</p>
        </div>
      );
    }

    return (
  <div className="heads">
    {showButton ? (
      <div style={{ marginTop: "15px" }}>
        <button
          onClick={this.handleGetInvoiceDetails}
          className="btn btn-primary"
        >
          Get Invoice Details
        </button>
      </div>
    ) : (
      <>
        {invoiceData.is_valid === "0" || invoiceData.is_valid === 0 ? (
          <div
            style={{
              backgroundColor: "#ffe6e6",
              border: "1px solid #ff4d4d",
              borderRadius: "6px",
              padding: "10px",
              marginBottom: "15px",
              textAlign: "center",
              fontWeight: "bold",
              color: "#b30000",
            }}
          >
            Invalid Invoice
          </div>
        ) : null}

        {(invoiceData.is_valid === "0" || invoiceData.is_valid === 0) && (
          <hr style={{ border: "1px solid #ddd", margin: "10px 0" }} />
        )}

        <div className="first">
          <div className="firstbox">
            <span>Invoice Number</span>
            <p>{invoiceData.invoice_number || "N/A"}</p>
          </div>
          <div className="secondbox">
            <span>Invoice Date</span>
            <p>{invoiceData.invoice_date || "N/A"}</p>
          </div>
          <div className="thirdbox">
            <span>Seller Name</span>
            <p>{invoiceData.seller_name || "N/A"}</p>
          </div>
          <div className="thirdbox">
            <span>Platform bought from</span>
            <p>{invoiceData.platform || "N/A"}</p>
          </div>
        </div>

        <div className="second">
          <div className="firstbox">
            <span>Buyer Name</span>
            <p>{invoiceData.buyer_name || "N/A"}</p>
          </div>
          <div className="secondbox">
            <span>Product Name</span>
            <p>{invoiceData.product_name || "N/A"}</p>
          </div>
          <div className="thirdbox">
            <span>City</span>
            <p>{invoiceData.city || "N/A"}</p>
          </div>
        </div>

        <div className="third">
          <div className="firstbox">
            <span>Total Amount</span>
            <p>{invoiceData.total_amount || "N/A"}</p>
          </div>
          <div className="secondbox">
            <span>Tax Amount</span>
            <p>{invoiceData.tax_amount || "N/A"}</p>
          </div>
          <div className="thirdbox">
            <span>State</span>
            <p>{invoiceData.state || "N/A"}</p>
          </div>
        </div>
      </>
    )}
  </div>
);

  }
}

export default connect()(InvoiceDetails);
